/* eslint-env browser */
import root from 'window-or-global';

export interface DataRow {
    [key: string]: string | number | null | undefined;
}

export type Data = DataRow[];

export interface HeaderItem {
    key: string;
    label: string;
}

export type Headers = HeaderItem[];

export type Formatter = (
    value: string | number | boolean | null | undefined,
    property: string
) => string;

const defaultFormatter: Formatter = value => String(value || '');

export const isSafari = (): boolean =>
    /^((?!chrome|android).)*safari/i.test(root.navigator.userAgent);

export const getDefaultHeaders = (data: Data): Headers =>
    Array.from(new Set(data.reduce((acc, row) => [...acc, ...Object.keys(row)], []))).map(
        header => ({key: header, label: header})
    );

export const getHeaderValue = (property: string, obj: DataRow, formatter: Formatter): string =>
    obj.hasOwnProperty(property) ? formatter(obj[property], property) : ' ';

export const rowsToArrays = (
    data: Data,
    headers?: Headers,
    formatter: Formatter = defaultFormatter
): string[][] => {
    const headersArray = headers || getDefaultHeaders(data);

    const headerLabels = headersArray.map(header => header.label);
    const headerKeys = headersArray.map(header => header.key);

    return [
        headerLabels,
        ...data.map(obj => headerKeys.map(key => getHeaderValue(key, obj, formatter)))
    ];
};

export const joiner = (data: string[][]): string => {
    return data
        .filter(e => e)
        .map(row => row.map(column => `"${column}"`).join(','))
        .join(`\n`);
};

export const buildURI = (csv: string): string => {
    const type = isSafari() ? 'application/csv' : 'text/csv';
    const blob = new Blob(['\uFEFF', csv], {type});
    const dataURI = `data:${type};charset=utf-8,${'\uFEFF'}${csv}`;

    const URL = window.URL || window.webkitURL;

    return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};
